import gql from 'graphql-tag'

import { MaintenanceBaseFragment } from '@/graphql/fragments/public/maintenance'

export const mutation = gql`
  ${MaintenanceBaseFragment}
  mutation deleteMaintenance($id: Int!) {
    record: delete_maintenance_by_pk(id: $id) {
      ...MaintenanceBase
    }
  }
`

export default mutation
